/**
 * 로그아웃 관련 유틸리티 함수들
 * Spring Authorization Server 표준 OIDC RP-Initiated Logout 지원
 */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { getValidIdToken } from './token-validation-utils';
import { performFullCleanup } from './cleanup-utils';
import { performOidcLogout } from './oidc-logout-utils';
/**
 * WebAuthProvider용 간단한 로그아웃 함수
 * authserver 세션을 정리하기 위해 가능한 경우 id_token_hint를 붙이고, 없더라도 logout endpoint를 호출한다.
 */ export var performWebLogout = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(navigate, authConfig, storageKeys) {
        var rawIdToken, allAuthKeys, idToken;
        return _ts_generator(this, function(_state) {
            console.log('[AuthUtils] 🚪 WebAuthProvider 로그아웃 시작');
            // localStorage 상태 디버깅
            rawIdToken = localStorage.getItem((storageKeys === null || storageKeys === void 0 ? void 0 : storageKeys.idTokenKey) || 'auth_id_token');
            console.log('[AuthUtils] 🔍 Raw ID Token 존재 여부:', !!rawIdToken);
            if (rawIdToken) {
                console.log('[AuthUtils] 🔍 Raw ID Token 앞 20자:', rawIdToken.substring(0, 20) + '...');
            }
            // 모든 auth 관련 localStorage 키 확인
            allAuthKeys = Object.keys(localStorage).filter(function(key) {
                return key.startsWith('auth_');
            });
            console.log('[AuthUtils] 🔍 모든 auth 키들:', allAuthKeys);
            idToken = getValidIdToken(storageKeys);
            console.log('[AuthUtils] 🔍 유효한 ID 토큰 존재 여부:', !!idToken);
            console.log('[AuthUtils] ✅ 로컬 정리 후 OIDC 로그아웃 호출');
            performFullCleanup(storageKeys);
            console.log('[AuthUtils] 🔄 performOidcLogout 호출 시작');
            performOidcLogout(navigate, authConfig, idToken);
            console.log('[AuthUtils] 🔄 performOidcLogout 호출 완료');
            return [
                2
            ];
        });
    });
    return function performWebLogout(navigate, authConfig, storageKeys) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * React 상태 초기화 헬퍼 함수
 */ var initializeAuthState = function(config) {
    config.setAuthState({
        user: null,
        token: null,
        isAuthenticated: false,
        isLoading: false,
        isInitialized: true,
        error: null
    });
    config.lastTokenRef.current = null;
    config.tokenManager.setToken(null);
    config.apiService.setToken(null);
};
/**
 * VSCode 환경용 로그아웃 처리
 */ var handleVSCodeLogout = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(config) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log('[AuthUtils] VSCode 환경 로그아웃 시작');
                    if (!config.ideMessengerInstance) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        config.ideMessengerInstance.request('edusenseLogout', {})
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    // VSCode 환경에서도 전체 정리
                    performFullCleanup(config.storageKeys);
                    // VSCode 환경 상태 초기화
                    initializeAuthState(config);
                    console.log('[AuthUtils] VSCode 로그아웃 완료');
                    config.navigate('/landing?logout=true&env=vscode');
                    return [
                        2
                    ];
            }
        });
    });
    return function handleVSCodeLogout(config) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 웹 환경용 로그아웃 처리
 */ var handleWebLogout = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(config) {
        var idToken;
        return _ts_generator(this, function(_state) {
            console.log('[AuthUtils] 웹 환경 로그아웃 시작');
            idToken = getValidIdToken(config.storageKeys);
            console.log('[AuthUtils] 로컬 정리 후 OIDC 호출', {
                hasIdToken: !!idToken
            });
            performFullCleanup(config.storageKeys);
            initializeAuthState(config);
            performOidcLogout(config.navigate, config.authConfig, idToken);
            return [
                2
            ];
        });
    });
    return function handleWebLogout(config) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * 로그아웃 함수 생성
 * 
 * @param config 로그아웃 설정
 */ export var createLogoutHandler = function(config) {
    return /*#__PURE__*/ _async_to_generator(function() {
        var error, errorMessage;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log('🟡🟡🟡 createLogoutHandler 호출됨! 🟡🟡🟡');
                    console.log('🟡🟡🟡 이 로그가 보이면 useAuthProvider가 사용되고 있습니다! 🟡🟡🟡');
                    console.log('[AuthUtils] 로그아웃 시작');
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        ,
                        7
                    ]);
                    if (!config.isVSCodeEnv) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleVSCodeLogout(config)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    return [
                        4,
                        handleWebLogout(config)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        7
                    ];
                case 6:
                    error = _state.sent();
                    console.error('[AuthUtils] 로그아웃 중 오류:', error);
                    // 오류 발생 시에도 최소한의 상태 초기화
                    initializeAuthState(config);
                    errorMessage = _instanceof(error, Error) ? error.message : 'logout_error';
                    config.navigate("/landing?logout=true&error=".concat(encodeURIComponent(errorMessage)));
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
};
